/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type WorkspaceAdminContactInfoFragment = {
  readonly __typename: "User";
  readonly id: c.UserId;
  readonly name: string | null;
  readonly email: string;
};

export type WorkspaceAdminsQueryVariables = Types.Exact<{
  orgId: Types.Scalars["OrgId"]["input"];
}>;

export type WorkspaceAdminsQuery = {
  readonly __typename: "Query";
  readonly orgById: {
    readonly __typename: "Org";
    readonly id: c.OrgId;
    readonly workspaceAdmins: ReadonlyArray<{
      readonly __typename: "User";
      readonly id: c.UserId;
      readonly name: string | null;
      readonly email: string;
    }>;
  };
};

export const WorkspaceAdminContactInfoFragmentDoc = /*#__PURE__*/ gql`
  fragment WorkspaceAdminContactInfo on User {
    id
    name
    email
  }
`;
export const WorkspaceAdminsDocument = /*#__PURE__*/ gql`
  query WorkspaceAdmins($orgId: OrgId!) {
    orgById(orgId: $orgId) {
      id
      workspaceAdmins {
        id
        ...WorkspaceAdminContactInfo
      }
    }
  }
  ${WorkspaceAdminContactInfoFragmentDoc}
`;

/**
 * __useWorkspaceAdminsQuery__
 *
 * To run a query within a React component, call `useWorkspaceAdminsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceAdminsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceAdminsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useWorkspaceAdminsQuery(
  baseOptions: Apollo.QueryHookOptions<
    WorkspaceAdminsQuery,
    WorkspaceAdminsQueryVariables
  > &
    (
      | { variables: WorkspaceAdminsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WorkspaceAdminsQuery, WorkspaceAdminsQueryVariables>(
    WorkspaceAdminsDocument,
    options,
  );
}
export function useWorkspaceAdminsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorkspaceAdminsQuery,
    WorkspaceAdminsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WorkspaceAdminsQuery,
    WorkspaceAdminsQueryVariables
  >(WorkspaceAdminsDocument, options);
}
// @ts-ignore
export function useWorkspaceAdminsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WorkspaceAdminsQuery,
    WorkspaceAdminsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  WorkspaceAdminsQuery,
  WorkspaceAdminsQueryVariables
>;
export function useWorkspaceAdminsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkspaceAdminsQuery,
        WorkspaceAdminsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WorkspaceAdminsQuery | undefined,
  WorkspaceAdminsQueryVariables
>;
export function useWorkspaceAdminsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkspaceAdminsQuery,
        WorkspaceAdminsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WorkspaceAdminsQuery,
    WorkspaceAdminsQueryVariables
  >(WorkspaceAdminsDocument, options);
}
export type WorkspaceAdminsQueryHookResult = ReturnType<
  typeof useWorkspaceAdminsQuery
>;
export type WorkspaceAdminsLazyQueryHookResult = ReturnType<
  typeof useWorkspaceAdminsLazyQuery
>;
export type WorkspaceAdminsSuspenseQueryHookResult = ReturnType<
  typeof useWorkspaceAdminsSuspenseQuery
>;
export type WorkspaceAdminsQueryResult = Apollo.QueryResult<
  WorkspaceAdminsQuery,
  WorkspaceAdminsQueryVariables
>;
